import ActionTypes from "./types";
import httpClient from "../../lib/HttpClient";

const addReferenceStampImage = (xfdfHighlightString) => {
  let stampImageTag;
  const regexOne = /<imagedata><\/imagedata>/;
  const regexTwo = /<imagedata\/>/;

  if (xfdfHighlightString.match(regexOne)) {
    stampImageTag = /<imagedata><\/imagedata>/;
  } else if (xfdfHighlightString.match(regexTwo)) {
    stampImageTag = /<imagedata\/>/;
  }

  const xfdfWithStampImages = xfdfHighlightString.replace(
    stampImageTag,
    "<imagedata>data:image/svg+xml;base64,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</imagedata>"
  );

  return xfdfWithStampImages;
};

const addStampImageToPinReferences = (references) => {
  const referencesWithStamps = references.map((reference) => {
    if (!reference.caption || reference.caption === "null") {
      reference.xfdf_highlight_string = addReferenceStampImage(
        reference.xfdf_highlight_string
      );
      return reference;
    } else {
      return reference;
    }
  });

  return referencesWithStamps;
};

export default (id) => (dispatch) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await httpClient.get(
        `/documents/${id}/all/references.json`
      );

      dispatch({
        type: ActionTypes.FETCH_DOCUMENT_REFERENCES,
        payload: addStampImageToPinReferences(response.data),
      });
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
